/**
 * @generated SignedSource<<6262d16630c1f3ac8dcd6e24b13491e3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AppPushDeleteInput = {
  id: string;
};
export type AppPushId_appPushDeleteMutation$variables = {
  input: AppPushDeleteInput;
};
export type AppPushId_appPushDeleteMutation$data = {
  readonly appPushDelete: {
    readonly id: string;
  };
};
export type AppPushId_appPushDeleteMutation = {
  response: AppPushId_appPushDeleteMutation$data;
  variables: AppPushId_appPushDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AppPushId_appPushDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AppPush",
        "kind": "LinkedField",
        "name": "appPushDelete",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AppPushId_appPushDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AppPush",
        "kind": "LinkedField",
        "name": "appPushDelete",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteRecord",
            "key": "",
            "kind": "ScalarHandle",
            "name": "id"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3c6c29ee468d24686513f3adf867d0e4",
    "id": null,
    "metadata": {},
    "name": "AppPushId_appPushDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation AppPushId_appPushDeleteMutation(\n  $input: AppPushDeleteInput!\n) {\n  appPushDelete(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "4067479fabeaa01f0d0d040a333d19c2";

export default node;
